import React, { Component } from 'react';
import '../../App.css';

import Modal from 'react-responsive-modal';
import request from 'request-promise-native';

import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Form from 'react-bootstrap/lib/Form';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Button from 'react-bootstrap/lib/Button';
import HelpBlock from "react-bootstrap/lib/HelpBlock";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Alert from "react-bootstrap/lib/Alert";
import ValidatedFormComponent from "../ValidatedFormComponent";
import {Row} from "react-bootstrap";

const ADD_CARD_ENDPOINT = "https://qibipay.azurewebsites.net/api/CardAdd";
const MAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class AddDeviceModal extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - open
             - onClose
             - onCardAdd
             - logout
        */
        super(props);

        this.state = {
            errors: {

            },

            loading: false,
            success: false
        }
    }

    async submit() {
        if(this.idRef.validated() && this.creditRef.validated() && this.voucherRef.validated() && this.sendViaMailRef.validated()) {
            if(this.sendViaMailRef.value=="true") {
                if(!this.mailRef.validated()) {
                    return;
                }
            }
            this.setState({loading: true, errors:{}, errorMessage:null});

            const options = {
                method: 'POST',
                uri: ADD_CARD_ENDPOINT,
                body: {
                    access_code: this.props.access_code,
                    credit: this.creditRef.value,
                    card_id: this.idRef.value,
                    voucher: this.voucherRef.value==="true",
                    name: this.nameRef.value,
                    personId: this.personIdRef.value,
                    mail: this.sendViaMailRef.value=="true" ? this.mailRef.value : null
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            this.setState({loading: false});

            if(response.statusCode===404) {
                this.props.logout();
                return;
            }

            if(response.statusCode===400) {
                this.setState({errorMessage: response.body.msg});
                return;
            }

            if(response.statusCode!==200) {
                this.setState({errorMessage: 'Server error occured, please retry.'});
                return;
            }

            this.setState({
                success: true
            });

            //Success
            this.props.onCardAdd(response.body.card);
        }
    }

    reset() {
        this.setState({
            errors: {

            },

            loading: false,
            success: false
        });
        this.props.onClose();
    }

    render() {
        return(
            <Modal open={this.props.open} onClose={this.reset.bind(this)} styles={{
                modal: {
                }
            }} >
                <h2>Add Card</h2>

                {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                    <strong>{this.state.errorMessage}</strong>
                </Alert>) : ''}

                {this.state.loading ? (
                    <div>
                        <p>Adding card...</p>
                        <ProgressBar  active now={100}/>
                    </div>
                ) : this.state.success ? (
                    <div>
                        <p>Card added successfully!</p>
                    </div>
                ) : (
                    <Form horizontal style={{
                        marginLeft: "32px",
                        marginRight: "32px"
                    }}>
                        <ValidatedFormComponent name="Identification"
                                                type="text"
                                                placeholder="Enter ID"
                                                onChange={(val) => {
                                                    this.setState({
                                                        cardId: val
                                                    })
                                                }}
                                                value={this.state.cardId}
                                                onValidate={input => {
                                                    return /^[0-9]*$/.test(input) ? null : "Card identification can only contain numbers!";
                                                }}
                                                inputRef={ref => this.idRef=ref}
                                                />
                        <Row>
                            <Col sm={4}/>
                            <Col sm={8}>
                                <Button bsStyle="primary" onClick={() => {
                                    let str = "";
                                    for(let i=0;i<10;i++) {
                                        str+=Math.floor(Math.random()*10);
                                    }
                                    this.setState({
                                        cardId: str
                                    });
                                }}>
                                    Generate random ID
                                </Button>
                            </Col>
                        </Row>
                        <br/>
                        <ValidatedFormComponent name="Person ID"
                                                type="text"
                                                placeholder="(optional) Enter person ID"
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                inputRef={ref => this.personIdRef=ref}
                        />
                        <ValidatedFormComponent name="Name"
                                                type="text"
                                                placeholder="(optional) Enter name"
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                inputRef={ref => this.nameRef=ref}
                        />
                        <ValidatedFormComponent name="Credit"
                                                type="number"
                                                decimal
                                                min={0}
                                                step={0.01}
                                                placeholder="Enter initial credit"
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                inputRef={ref => this.creditRef=ref}
                                                />
                        <ValidatedFormComponent name="Voucher"
                                                type="boolean"
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                inputRef={ref => this.voucherRef=ref}
                        />
                        <ValidatedFormComponent name="Send via mail"
                                                type="boolean"
                                                onChange={(val) => {
                                                    this.setState({
                                                        sendViaMail: val
                                                    });
                                                }}
                                                value={this.state.sendViaMail}
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                inputRef={ref => this.sendViaMailRef=ref}
                        />
                        {this.state.sendViaMail=="true" ? (
                            <ValidatedFormComponent name="E-mail"
                                                    type="text"
                                                    onValidate={input => {
                                                        return MAIL_REGEX.test(input) ? null : "Not a valid e-mail!";
                                                    }}
                                                    placeholder={"Enter customer's e-mail"}
                                                    inputRef={ref => this.mailRef=ref}
                            />
                        ) : ""}
                        <Col sm={4}/>
                            <Col sm={8}>
                            <Button bsStyle="primary" onClick={this.submit.bind(this)}>
                                Add Card
                            </Button>
                        </Col>
                    </Form>
                )}
            </Modal>
        );
    }

}

export default AddDeviceModal;